module.exports = __webpack_public_path__ + "img/plus.7b4aca42.svg";